import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import "./main.less";
import "./main-mobile.less";
import Checkmark from '../../../assets/checkmark.svg';
import Desktop from '../../../assets/desktop-solid.svg';
import InfoIcon from '../../../assets/circle-info-solid.svg';
import DownloadWhite from '../../../assets/download-white.svg';
import MobileScreen from '../../../assets/mobile-screen-button-solid.svg';
import CheckmarkLightBlue from '../../../assets/checkmark-light-blue.svg';
import QrcodeSolid from '../../../assets/qrcode-solid.svg'
import Plug from '../../../assets/plug-solid.svg';
import ProButton from '../../shared/pro-button/pro-button';
import OutageBanner from '../../shared/outage-banner/outage-banner';
import VideoSection from '../video-section/video-section';
import VideoSectionWistia from '../video-section/video-section-wistia';
import QrCode from '../qr-code/qrcode';
import { useTranslation } from 'react-i18next';
import { getLocalTime } from './main-helper';
import { getDownloadUserGuideUrl, getSecondCameraVideoUrl } from '../../util/util';
import { getDownloadCamReadinessGuideUrl} from '../../util/util';
import SystemCheck from '../system-check/system-check';
import ProModal from '../../shared/pro-modal/pro-modal';
import { isMobileDevice } from '../../util/util';
import { NewRelic } from '../../../lib/new-relic';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../../hooks/use-app-context';
import { Locations } from '../../../lib/locations';

const KNOWLEDGE_BASE_URL = process.env.REACT_APP_KNOWLEDGE_BASE_URL as string;
const MAC_MIN_EXCLUED_VERSION = process.env.REACT_APP_MAC_MIN_EXCLUDED_VERSION as string;
const MAC_MAX_EXCLUED_VERSION = process.env.REACT_APP_MAC_MAX_EXCLUDED_VERSION as string;
let MAC_OTHER_EXCLUDED_VERSION = process.env.REACT_APP_MAC_OTHER_EXCLUDED_VERSION as string;
const PROPROCTOR_WEB_URL = process.env.REACT_APP_PROPROCTOR_EXAM_WEB_URL as string;
const ENVIRONMENT_NAME = process.env.REACT_APP_ENVIRONMENT_NAME;

const CHECKING_SMARTPHONE_URL = process.env.REACT_APP_CHECKING_SMARTPHONE_URL as string;

let langParam = '';

let checkMacExcludedVersionOther = false;
if (process.env.REACT_APP_MAC_CHECK_OTHER_EXCLUDED_VERSION?.toLocaleLowerCase() === 'true') {
    checkMacExcludedVersionOther = true;
}

function Main(props: any) {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { setExamConfig, clearState } = useAppContext();
    const [isEu, setIsEu] = useState(false);
    const [examDate, setExamDate] = useState('');
    const [examTime, setExamTime] = useState('') ;
    const [showSystemCheck, setShowSystemCheck] = useState(false);
    const [pageAnnouncement, setPageAnnouncement] = useState('');
    const [langBaseCheckSmartphoneUrl, setLangBaseCheckSmartphoneUrl] = useState('');
    const PROPROCTOR_APP = t("MAIN_PROPROCTOR_DESKTOP_APP");
    const PROPROCTOR_IN_BROWSER = t("MAIN_PROPROCTOR_IN_BROWSER");

    useEffect(() => {
      if (props.examSession?.examConfig) {
        setExamConfig(props.examSession.examConfig);
      }
    }, [props.examSession]);

    useEffect(() => {
      if (props.isFreezeActive) {
        clearState();
        navigate('/', { replace: true });
      }
    }, [props.isFreezeActive]);

    useEffect(() => {
        setIsEu(ENVIRONMENT_NAME === "neuprod");
        setPageAnnouncement(t("MAIN_PAGE_LOADED_ANNOUNCEMENT"));
        logNewRelicInfo();
    }, []);
    
    useEffect(() => {
        const dateTime = getLocalTime(props.examSession, i18n.language);
        setExamDate(dateTime.date);
        setExamTime(dateTime.time);
        langParam = i18n.language === "zho" ? "zh-tw" : (i18n.language === "zh" ? "zh-cn" : i18n.language);
        setLangBaseCheckSmartphoneUrl(`${CHECKING_SMARTPHONE_URL}?lang=${langParam}`);
    }, [i18n.language, props.examSession.examTimeUTC, props.examSession.scheduledStartTime]);

    const logNewRelicInfo = () => {
        NewRelic.setCandidateSessionInfoContext({
            address : props.examSession.address,
            eligibilityCode : props.examSession.eligibilityCode,
            deliveryMode : props.examSession.deliveryMode,
            examCode : props.examSession.examCode,
            examDate : props.examSession.examTimeUTC,
            examId : props.examSession.examId,
            programCode : props.examSession.programCode,
            clientCode : props.examSession.clientCode,
            confirmationNumber : props.examSession.confirmationNumber
        });
    }  

    const redirectToSystemCheckSteps = () => {
      navigate(Locations.examSystemCheck, { replace: true });
    }

    const renderTextItems = (
        items: {
            key: string,
            url?: string,
            icon?: string,
            iconName?: string,
            iconStyle?: string,
        }[]
    ) => {
        return items.map((item, id) => (
            <li key={id} className="main-text-item">
                {item.icon && (
                    <img
                        src={item.icon}
                        className={item.iconStyle ? item.iconStyle : "main-checkmark-icon"}
                        aria-hidden="true"
                        alt={item.iconName ? item.iconName : ""}
                    />
                )}
                <div className="main-info-text">
                    {item.url ? <Trans
                        i18nKey={item.key}
                        components={[<a className='main-text-link' href={item.url} target="_blank" />]}></Trans> : <Trans i18nKey={item.key}></Trans>}
                </div>
            </li>
        ));
    };

    const renderYourExam = () => {
        return(
            <>
                <section className="main-prepare-your-exam">
                    <div className='main-left-check-icon'>
                        <img className='main-title-check-mark-icon' src={CheckmarkLightBlue} aria-hidden="true" alt="" />
                        <div className="main-vertical-line"></div>
                    </div>
                    
                    <div  className="section-contents"> 
                        <h2 className='main-text-label-exam'>{t('MAIN_START_PREPAREING_FOR_EXAM')}</h2>

                        <div className='section-contents-detail'>
                            <div className='main-text-item'>
                                <span className='icon-section'>
                                    <i className="fa-solid fa-user" ></i>
                                </span>
                                <p className='main-list-value'> {props.examSession.fullName}</p>
                            </div>
                            <div className='main-text-item'>
                                <span className='icon-section'>
                                    <i className="fa-solid fa-graduation-cap"></i>
                                </span>
                                <p className='main-list-value'> {props.examSession.examName}</p>
                            </div>
                            <div className='main-text-item'>
                                <span className='icon-section'>
                                    <i className="fa-solid fa-calendar" ></i>
                                </span>
                                <p className='main-list-value'> {examDate}</p>
                            </div>
                            <div className='main-text-item'>
                                <span className='icon-section'>
                                    <i className="fa-solid fa-clock" ></i>
                                </span>
                                <p className='main-list-value'>{`${examTime}`}</p>
                            </div>
                            <hr className="main-divider"></hr>

                            {props.examSession.isSecCameraRequired?
                            <>
                                <ul>
                                    {renderTextItems([
                                        {
                                            key: 'MAIN_YOU_ARE_TAKING_PROPROCTOR_LIVE_SEC_CAMERA',
                                            icon: Desktop,
                                            iconName: "info icon"
                                        },  
                                        {
                                            key: 'MAIN_YOU_NEED_A_MOBILE_DEVICE',
                                            icon: MobileScreen,
                                            iconName: "info icon"
                                        },
                                        {
                                            key: 'MAIN_ENSURE_MOBILE_DEVICE_DISTANCE',
                                            icon: Plug,
                                            iconName: "info icon"
                                        }
                                    ])}
                                </ul>
                                <div className='main-text-item'>
                                    <span className='icon-section'>
                                        <img src={DownloadWhite} aria-hidden="true" alt=""></img>
                                    </span>
                                    <p > <Trans values={{ProProctorApp: (PROPROCTOR_APP) }}>MAIN_YOU_NEED_TO_DOWNLOAD</Trans> </p>
                                </div>
                            </> 
                            : 
                            <>
                                <div className='main-text-item'>
                                    <span className='icon-section'>
                                        <i className="fa-solid fa-desktop exam-session" ></i>
                                    </span>
                                    <div>
                                        {props.examSession.isWebAI? <p className='main-list-value exam-session'> <Trans>MAIN_YOU_ARE_TAKING_PROPROCTOR_AI_WEB</Trans> </p> : ''}
                                        {props.examSession.isProproctorAI? <p className='main-list-value exam-session'> <Trans>MAIN_YOU_ARE_TAKING_PROPROCTOR_AI</Trans> </p> : ''}
                                        {props.examSession.isProproctorLive? <p className='main-list-value exam-session'> <Trans>MAIN_YOU_ARE_TAKING_PROPROCTOR_LIVE</Trans> </p> : ''}
                                        {props.examSession.isWebAI? <p className='main-list-value exam-session exam-session-bold-text'> <Trans values={{ProProctorBrowser: (PROPROCTOR_IN_BROWSER) }}>MAIN_PROPROCTOR_TAKING_BROWSER_EXAM</Trans> </p> :
                                            <p className='main-list-value exam-session exam-session-bold-text'> <Trans values={{ProProctorApp: (PROPROCTOR_APP) }}>MAIN_YOU_NEED_TO_DOWNLOAD</Trans> </p>}   
                                    </div>
                                </div>
                            </>}
                            {props.isFreezeActive && <OutageBanner />}
                        </div>
                    </div>
                </section>
            </>
        )
    }

    const renderBeforeTestDay = (isEu: boolean, language: string) =>{
        return(
            <>  
                <section className="main-prepare-your-exam">
                    <div className='main-left-check-number'>
                        <div className="circle">1</div> 
                        <div className="main-vertical-line"></div>
                    </div>
                    <div className="section-contents"> 
                        <h2 className='main-text-label'>{t('MAIN_BEFORE_YOU_TEST')}</h2>
                        <h3 className='main-text-label-list-title'> {t('MAIN_GET_PREPARED')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: isEu? 'MAIN_PLEASE_ENSURE_REVIEW_USER_GUIDE' : 'MAIN_PLEASE_ENSURE_REVIEW_USER_GUIDE_ADDITIONALLY',
                                    icon: Checkmark,
                                    iconName: "info icon"
                                },  
                            ])}
                        </ul>
                        <div className='main-button-user-guide-left'>
                            <ProButton
                                text={t('MAIN_DOWNLOAD_USER_GUIDE')}
                                colorscheme="secondary"
                                size="medium"
                                icon="download"
                                iconType="fa-solid fa-download fa-lg"
                                classname="fullwidth download bold-text"
                                iconPosition="left"
                                download="doc"
                                downloadUrl={getDownloadUserGuideUrl(ENVIRONMENT_NAME!, language)}
                                onClick={() => {
                                    console.log('clicked')
                                }}
                            />   
                        </div>
                        {!isEu&&
                            <div className='main-video-section'>
                                <VideoSection url={process.env.REACT_APP_VIDEO_URL}></VideoSection>
                            </div>
                        }
                        {props.examSession.isWebAI? renderSetupYourSystemWeb(showSystemCheck, setShowSystemCheck): renderSetupYourSystemApp()}
                    </div>
                </section>        
            </>
        )
    }

    const renderBeforeTestDaySecCamera = (isEu: boolean, language: string) =>{
        return(
            <>  
                <section className="main-prepare-your-exam">
                    <div className='main-left-check-number'>
                        <div className="circle">1</div> 
                        <div className="main-vertical-line"></div>
                    </div>
                    <div className="section-contents"> 
                        <h2 className='main-text-label'>{t('MAIN_BEFORE_YOU_TEST')}</h2>
                        <h3 className='main-text-label-list-title'> {t('MAIN_GET_PREPARED')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: 'MAIN_TAKING_EXAM_WITH_MOBIL_DEVICE',
                                    icon: Checkmark,
                                    iconName: "info icon"
                                },  
                                {
                                    key: 'MAIN_ADDITIONALLY_WATCH_WHAT_TO_EXPECT_VIDEO',
                                    icon: Checkmark,
                                    iconName: "info icon"
                                },  
                            ])}
                        </ul>
                        <div className='second-camera-download-user-guide'>
                            <div className='main-button-user-guide-left user-guide-second-camera'>
                                <ProButton
                                    text={t('MAIN_DOWNLOAD_USER_GUIDE')}
                                    colorscheme="secondary"
                                    size="medium"
                                    icon="download"
                                    iconType="fa-solid fa-download fa-lg"
                                    classname="fit-content download bold-text"
                                    iconPosition="left"
                                    download="doc"
                                    downloadUrl={getDownloadUserGuideUrl(ENVIRONMENT_NAME!, language)}
                                    onClick={() => {
                                        console.log('clicked')
                                    }}
                                />   
                            </div>
                            <div className='main-button-user-guide-right quick-start-guide'>
                                <ProButton
                                    text={t('MAIN_DOWNLOAD_SECOND_CAMERA_READINESS_GUIDE')}
                                    colorscheme="secondary"
                                    size="medium"
                                    icon="download"
                                    iconType="fa-solid fa-download fa-lg"
                                    classname="fit-content download bold-text"
                                    iconPosition="left"
                                    download="doc"
                                    downloadUrl={getDownloadCamReadinessGuideUrl(ENVIRONMENT_NAME!, language)}
                                    onClick={() => {
                                        console.log('clicked')
                                    }}
                                />   
                            </div>
                        </div>
                        
                        <div className='main-video-section'>
                            <VideoSection url={process.env.REACT_APP_VIDEO_URL}></VideoSection>
                        </div>
                        <div className='main-video-section'> 
                            <VideoSectionWistia url={getSecondCameraVideoUrl(language)}></VideoSectionWistia>               
                        </div>

                        {props.examSession.isWebAI? renderSetupYourSystemWeb(showSystemCheck, setShowSystemCheck): renderSetupYourSystemApp()}
                        {renderCheckingSmartPhone()}
                    </div>
                </section>        
            </>
        )
    }
    const renderCheckingSmartPhone = () => {
        return(
            <>
                <section className="main-checking-your-smartphone">
                    <div  className="section-contents"> 
                        <h3 className='main-text-label-list-title'>{t('MAIN_SEC_CAMERA_CHECKING_YOUR_SMARTPHONE')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: 'MAIN_SEC_CAMERA_CHECK_YOUR_SMARTPHONE_BTN',
                                    icon: MobileScreen,
                                    iconName: "info icon"
                                },  
                                {
                                    key: 'MAIN_SEC_CAMERA_SCAN_QR_CODE_WITH_SMARTPHONE',
                                    icon: QrcodeSolid,
                                    iconName: "info icon"
                                },
                            ])}
                        </ul>
                        <div className='section-contents-detail'>
                        <ul>
                            {renderTextItems([
                                {
                                    key: 'MAIN_SEC_CAMERA_TO_SCAN_QR_CODE',
                                    icon: InfoIcon,
                                    iconName: "info icon"
                                },  
                            ])}
                        </ul>
                        </div>
                        <div className="flex-container">
                            <div className='check-your-smartphone'>
                                <h4 className='main-text-label-title-4'>{t('MAIN_SEC_CAMERA_CHECK_YOUR_SMARTPHONE')}</h4>
                                <ProButton
                                    text={i18n.t('MAIN_SEC_CAMERA_CHECK_YOUR_SMARTPHONE_BTN_LABEL')}
                                    colorscheme="secondary"
                                    size="medium"
                                    icon="fa-mobile-screen"
                                    iconType="fa-solid fa-mobile-screen fa-lg"
                                    classname="fullwidth download bold-text"
                                    iconPosition="left"
                                    download="doc"
                                    downloadUrl= { langBaseCheckSmartphoneUrl }
                                    onClick={() => {
                                        console.log('clicked')
                                    }}
                                />

                            </div>
                            <div className='scan-qrcode'>
                                <h4 className='main-text-label-title-4'>{t('MAIN_SEC_CAMERA_SCAN_QR_CODE')}</h4>
                                <QrCode url={langBaseCheckSmartphoneUrl}/>
                            </div>   
                        </div>           
                    </div>
                </section>
            </>
        )
    }

    const renderBeforeTestDayWeb = (language: string) =>{
        return(
            <>  
                <section className="main-prepare-your-exam">
                    <div className='main-left-check-number'>
                        <div className="circle">1</div> 
                        <div className="main-vertical-line"></div>
                    </div>
                    <div className="section-contents"> 
                        <h2 className='main-text-label'>{t('MAIN_BEFORE_YOU_TEST')}</h2>
                        <h3 className='main-text-label-list-title'> {t('MAIN_READ_THE_GUIDE')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: 'MAIN_PLEASE_ENSURE_REVIEW_USER_GUIDE',
                                    icon: Checkmark,
                                    iconName: "info icon"
                                }, 
                                   {
                                    key: 'MAIN_PLAY_CLOSE_ATTENTION_TO_THE_AI_PLUS_POPIN_GUIDE',
                                    icon: Checkmark,
                                    iconName: "info icon"
                                }
                            ])}
                        </ul>
                        <div className='main-button-user-guide-left'>
                            <ProButton
                                text={t('MAIN_DOWNLOAD_USER_GUIDE')}
                                colorscheme="secondary"
                                size="medium"
                                icon="download"
                                iconType="fa-solid fa-lg"
                                classname="fullwidth download bold-text"
                                iconPosition="left"
                                download="doc"
                                downloadUrl={getDownloadUserGuideUrl(ENVIRONMENT_NAME!, language)}
                                onClick={() => {
                                    console.log('clicked')
                                }}
                            />
                        </div>

                        {props.examSession.isWebAI? renderSetupYourSystemWeb(showSystemCheck, setShowSystemCheck): renderSetupYourSystemApp()}
                    </div>
                </section>        
            </>
        )
    }

    const renderSetupYourSystemWeb = (showSystemCheck: boolean, setShowSystemCheck: { (value: React.SetStateAction<boolean>): void; (value: React.SetStateAction<boolean>): void; (value: React.SetStateAction<boolean>): void; (arg0: boolean): any; }) => {
        var width = window.screen.width;
        var height = window.screen.height;
        let features = `popup,width=${width},height=${height}`;
        const modalSysCheckTitles =
            <div className='warning-modal-title'>
                <i className="fa-solid fa-triangle-exclamation fa-xl icon-warning"></i>
                <h3 className='modal-title'>{t('LANDING_PAGE_SYS_CHECK_ON_SMART_PHONE_ERROR')}</h3>
            </div>
        return(
            <>
                <section className="main-prepare-your-exam">
                    <div  className="section-contents"> 
                    <h3 className='main-text-label-list-title'> {t('MAIN_CHECK_YOUR_SYSTEM')}</h3> 
                          <ul>
                            {renderTextItems([
                                {
                                    key: 'MAIN_USE_SAME_NETWORK_AS_YOUR_EXAM',
                                    icon: Checkmark,
                                    iconName: "info icon"
                                },
                                {
                                    key: 'MAIN_PLEASE_USE_CHROME_OR_EDGE',
                                    icon: Checkmark,
                                    iconName: "info icon"
                                },
                            ])}
                        </ul>
                        <div className='main-button-user-guide-left'>
                            <ProButton
                                text={t('LANDING_PAGE_CHECK_SYSTEM')}
                                colorscheme="secondary"
                                size="medium"
                                icon="list-check"
                                iconType="fa-solid fa-list-check fa-lg"
                                classname="landing-page-sys-check"
                                iconPosition="left"
                                download="none"
                                downloadUrl="#"
                                onClick={() => {
                                    redirectToSystemCheckSteps();
                                }}
                            />
                        </div>
                    </div>
                        {showSystemCheck && (
                            isMobileDevice() ? (
                                <ProModal
                                    type="warning"
                                    title={modalSysCheckTitles}
                                    className="warning-modal"
                                    content={
                                        <div>
                                        <p className='system-check-error-on-smartphone-first-para'>{t('LANDING_PAGE_SYS_CHECK_ON_SMART_PHONE_ERROR_FIRST_PARA')}</p> 
                                        <p>{t('LANDING_PAGE_SYS_CHECK_ON_SMART_PHONE_ERROR_SECOND_PARA')}</p> 
                                        </div>
                                    }
                                    buttons={[t('LANDING_PAGE_CLOSE')]}
                                    onButtonClick={() => setShowSystemCheck(false)}
                            />
                            ) : (
                                <SystemCheck isCheckBrowser={true} show={showSystemCheck} close={() => setShowSystemCheck(false)} />
                            )
                    )}
                </section>
            </>
        )
    }

    const renderSetupYourSystemApp = () => {
        MAC_OTHER_EXCLUDED_VERSION = process.env.REACT_APP_MAC_OTHER_EXCLUDED_VERSION as string;
        MAC_OTHER_EXCLUDED_VERSION = checkMacExcludedVersionOther ? `${t('AND')} ${MAC_OTHER_EXCLUDED_VERSION}` : "";
        return(
            <>
                <section className="main-prepare-your-exam">
                    <div  className="section-contents"> 
                        <h3 className='main-text-label-list-title'>{t('MAIN_SETUP_SYSTEM')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: 'MAIN_DOWNLOAD_AND_INSTALL_LATEST_VERSION_PROCTOR_APP',
                                    icon: Checkmark,
                                    iconName: "info icon"
                                },  
                                {
                                    key: 'MAIN_IF_YOU_ARE_TAKING_EXAM_ON_ORG',
                                    icon: InfoIcon,
                                    iconName: "info icon"
                                },
                            ])}
                        </ul>
                        <div className="flex-container">
                            <div className='main-button-download-left'>
                                <ProButton
                                    text={i18n.t('MAIN_DOWLOAD_FOR_WINDOWS')}
                                    colorscheme="secondary"
                                    size="medium"
                                    icon="fa-windows"
                                    iconType="fa-brands fa-windows fa-lg"
                                    classname="fullwidth download bold-text"
                                    iconPosition="left"
                                    download="doc"
                                    downloadUrl={process.env.REACT_APP_WIN_DOWNLOAD_URL as string}
                                    onClick={() => {
                                        console.log('clicked')
                                    }}
                                />
                                <p className='main-version-text'>
                                    {t('HEADER_WIN_VERSION', { version: process.env.REACT_APP_WIN_MIN_VERSION })}
                                </p>
                            </div>
                            <div className='main-button-download-right'>
                                <ProButton
                                    text={i18n.t('MAIN_DOWLOAD_FOR_MAC')}
                                    colorscheme="secondary"
                                    size="medium"
                                    icon="fa-apple"
                                    iconType="fa-brands fa-apple fa-lg"
                                    classname="fullwidth download bold-text"
                                    iconPosition="left"
                                    download="doc"
                                    downloadUrl={process.env.REACT_APP_MAC_DOWNLOAD_URL as string}
                                    onClick={() => {
                                        console.log('clicked')
                                    }}
                                />
                                <p className='main-version-text'>
                                    {t('HEADER_MAC_VERSION', { version: process.env.REACT_APP_MAC_MIN_VERSION })}
                                </p>
                                <p className='main-version-text-mac-os'>
                                    {t('HEADER_MAC_RANGE_VERSION', { macExcludedVersionMin: MAC_MIN_EXCLUED_VERSION, macExcludedVersionMax: MAC_MAX_EXCLUED_VERSION, macExcludedVersionOther: MAC_OTHER_EXCLUDED_VERSION })}
                                </p>
                            </div>   
                        </div>           
                    </div>
                </section>
            </>
        )
    }

    const renderOnTestDay = () =>{
        var width = window.screen.width;
        var height = window.screen.height;
        let features = `popup,width=${width},height=${height}`;
        return (
            <>
                <section className="main-prepare-your-exam">
                <div className='main-left-check-number'>
                        <div className="circle">2</div> 
                    </div>
                        <div  className="section-contents"> 
                        <h2 className='main-text-label'>{t('MAIN_WHAT_YOU_NEED_ON_TEST_DAY')}</h2>
                        <h3 className='main-text-label-list-title'> {t('MAIN_PREPARE_YOUR_DEVICE')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: "MAIN_RUN_ANOTHER_SYSTEM_CHECK",
                                    url: ' tobe added',
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_DONT_FORGET_DISABLE_VPNS",
                                    url: KNOWLEDGE_BASE_URL,
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_ENSURE_TO_CLOSE_ALL_APPS",
                                    url: ' tobe added',
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                }
                            ])}
                        </ul>
                        <h3 className='main-text-label-list-title'> {t('MAIN_PREPARE_TESTING_SPACE')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: "MAIN_ENSURE_SPACE_MEET_REQUIREMENTS",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                            ])}
                        </ul>
                        <h3 className='main-text-label-list-title'> {t('MAIN_PREPARE_YOUR_DOCUMENTS')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: "MAIN_HAVE_VALID_GOV_ID",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_HAVE_REGISTRATION_DETAILS_READY",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_CONSULT_WITH_YOUR_SPONSOR",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                            ])}
                        </ul>
                        <h3 className='main-text-label-list-title'> {t('MAIN_YOU_READY_TO_TEST')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: "MAIN_LAUNCH_THE_PROPROCTOR_APP",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_LOG_IN",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                            ])}
                        </ul>
                        { props.examSession.isWebAI?
                            <div className='main-button-user-guide-left'>
                                <ProButton
                                    text={t('MAIN_START_EXAM_IN_PROPROCTOR')}
                                    colorscheme="secondary"
                                    size="medium"
                                    icon="fa-arrow-up-right-from-square"
                                    iconType="fa-solid fa-arrow-up-right-from-square fa-lg"
                                    classname="fullwidth download bold-text check-propoctor"
                                    iconPosition="left"
                                    download="doc"
                                    downloadUrl={ PROPROCTOR_WEB_URL}
                                    features={ features }
                                    onClick={() => {
                                        console.log('clicked')
                                    }}
                                />
                            </div>: ''
                        }
                        <h3 className='main-text-label-title'> {t('MAIN_FURTHER_INFORMATION')}</h3>
                        <p>{t('MAIN_IF_YOU_REQUIRED_MORE_INFORMATION')}</p>
                    </div>
                </section>
            </>
        )
    }
    const renderOnTestDayWeb = () =>{
        var width = window.screen.width;
        var height = window.screen.height;
        let features = `popup,width=${width},height=${height}`;
        return (
            <>
                <section className="main-prepare-your-exam">
                <div className='main-left-check-number'>
                        <div className="circle">2</div> 
                    </div>
                        <div  className="section-contents"> 
                        <h2 className='main-text-label'>{t('MAIN_WHAT_YOU_NEED_ON_TEST_DAY')}</h2>
                        <h3 className='main-text-label-list-title'> {t('MAIN_PREPARE_YOUR_DEVICE')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: "MAIN_RUN_ANOTHER_SYSTEM_CHECK",
                                    url: ' tobe added',
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_ENSURE_TO_CLOSE_ALL_APPS",
                                    url: ' tobe added',
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                }
                            ])}
                        </ul>
                        <h3 className='main-text-label-list-title'> {t('MAIN_PREPARE_TESTING_SPACE')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: "MAIN_ENSURE_SPACE_MEET_REQUIREMENTS",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                            ])}
                        </ul>
                        <h3 className='main-text-label-list-title'> {t('MAIN_PREPARE_YOUR_DOCUMENTS')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: "MAIN_HAVE_VALID_GOV_ID",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_HAVE_REGISTRATION_DETAILS_READY",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_CONSULT_WITH_YOUR_SPONSOR",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                            ])}
                        </ul>
                        <h3 className='main-text-label-list-title'> {t('MAIN_WHAT_TO_EXPECT')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: "MAIN_DURING_CHECK_IN",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_YOU_WILL_NEED_TO_HOLD_YOUR_DEVICE",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_ENSURE_YOU_READ_THE_INSTRUCTION",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                  {
                                    key: "MAIN_IF_ANY_SECURITY_CONCERNS",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                  {
                                    key: "MAIN_YOU_WONT_BE_ABLE_TO_START_A_CHAT",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                            ])}
                        </ul>
                        <h3 className='main-text-label-list-title'> {t('MAIN_YOU_READY_TO_TEST')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: "MAIN_LAUNCH_THE_PROPROCTOR_AT_START_TIME",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_LOG_IN",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                            ])}
                        </ul>
                        { props.examSession.isWebAI?
                            <div className='main-button-user-guide-left'>
                                <ProButton
                                    text={t('MAIN_START_EXAM_IN_PROPROCTOR')}
                                    colorscheme="secondary"
                                    size="medium"
                                    icon="fa-arrow-up-right-from-square"
                                    iconType="fa-solid fa-arrow-up-right-from-square fa-lg"
                                    classname="fullwidth download bold-text check-propoctor"
                                    iconPosition="left"
                                    download="doc"
                                    downloadUrl={ PROPROCTOR_WEB_URL}
                                    features={ features }
                                    onClick={() => {
                                        console.log('clicked')
                                    }}
                                />
                            </div>: ''
                        }
                        <h3 className='main-text-label-title'> {t('MAIN_FURTHER_INFORMATION')}</h3>
                        <p>{t('MAIN_IF_YOU_REQUIRED_MORE_INFORMATION')}</p>
                    </div>
                </section>
            </>
        )
    }


    const renderOnTestDaySecCamera = () =>{
        var width = window.screen.width;
        var height = window.screen.height;
        let features = `popup,width=${width},height=${height}`;
        return (
            <>
                <section className="main-prepare-your-exam">
                <div className='main-left-check-number'>
                        <div className="circle">2</div> 
                    </div>
                        <div  className="section-contents"> 
                        <h2 className='main-text-label'>{t('MAIN_WHAT_YOU_NEED_ON_TEST_DAY')}</h2>
                        <h3 className='main-text-label-list-title'> {t('MAIN_PREPARE_YOUR_DESKTOP_DEVICE')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: "MAIN_RUN_ANOTHER_SYSTEM_CHECK",
                                    url: ' tobe added',
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_DONT_FORGET_DISABLE_VPNS",
                                    url: KNOWLEDGE_BASE_URL,
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_ENSURE_TO_CLOSE_ALL_APPS",
                                    url: ' tobe added',
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                }
                            ])}
                        </ul>
                        <h3 className='main-text-label-list-title'> {t('MAIN_PREPARE_YOUR_MOBILE_DEVICE')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: "MAIN_HAVE_A_FULLY_CHARGED_MOBILE_DEVICE",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_ENSURE_YOUR_MOBILE_IS_NOT_DISTRACTION",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_YOU_WILL_NOT_NEED_TO_DOWNLOAD_APP",
                                    icon: InfoIcon,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_DO_NOT_CONNECT_YOUR_DEVICE_TO_INTERNET",
                                    icon: InfoIcon,
                                    iconName: "Info icon"
                                },
                            ])}
                        </ul>
                        <h3 className='main-text-label-list-title'> {t('MAIN_PREPARE_TESTING_SPACE')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: "MAIN_ENSURE_SPACE_CONFROMS_WITH_REQUIREMENT",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_ENSURE_YOU_ABLE_TO_PLUGIN_YOUR_MOBILE",
                                    icon: InfoIcon,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_PLEASE_ENSURE_COMPLETED_SECOND_CAMERA_SETUP",
                                    icon: InfoIcon,
                                    iconName: "Info icon"
                                },
                            ])}
                        </ul>
                        <h3 className='main-text-label-list-title'> {t('MAIN_PREPARE_YOUR_DOCUMENTS')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: "MAIN_HAVE_VALID_GOV_ID",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_HAVE_REGISTRATION_DETAILS_READY",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_CONSULT_WITH_YOUR_SPONSOR",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                            ])}
                        </ul>
                        <h3 className='main-text-label-list-title'> {t('MAIN_YOU_READY_TO_TEST')}</h3>
                        <ul>
                            {renderTextItems([
                                {
                                    key: "MAIN_LAUNCH_THE_PROPROCTOR_APP",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                                {
                                    key: "MAIN_LOG_IN",
                                    icon: Checkmark,
                                    iconName: "Info icon"
                                },
                            ])}
                        </ul>
                        { props.examSession.isWebAI?
                            <div className='main-button-user-guide-left'>
                                <ProButton
                                    text={t('MAIN_START_EXAM_IN_PROPROCTOR')}
                                    colorscheme="secondary"
                                    size="medium"
                                    icon="fa-arrow-up-right-from-square"
                                    iconType="fa-solid fa-arrow-up-right-from-square fa-lg"
                                    classname="fullwidth download bold-text check-propoctor"
                                    iconPosition="left"
                                    download="doc"
                                    downloadUrl={ PROPROCTOR_WEB_URL}
                                    features={ features }
                                    onClick={() => {
                                        console.log('clicked')
                                    }}
                                />
                            </div>: ''
                        }
                        <h3 className='main-text-label-title'> {t('MAIN_FURTHER_INFORMATION')}</h3>
                        <p>{t('MAIN_IF_YOU_REQUIRED_MORE_INFORMATION')}</p>
                    </div>
                </section>
            </>
        )
    }

    return (
        <main className='main'>
            <div
                aria-live="polite" 
                role="status"      
                aria-atomic="true" 
                className="visually-hidden-aria-live" 
            >
                {pageAnnouncement}
            </div>
            <div className='main-wrapper'>
                <div className='main-left-content'>
                   {renderYourExam()}
                   {!props.isFreezeActive && <>
                       {props.examSession.isWebAI? renderBeforeTestDayWeb(i18n.language): null}
                       {props.examSession.isWebAI? renderOnTestDayWeb(): null}
                       {(props.examSession.isProproctorAI || props.examSession.isProproctorLive)? renderBeforeTestDay(isEu, i18n.language): null}
                       {(props.examSession.isProproctorAI || props.examSession.isProproctorLive)? renderOnTestDay(): null}
                       {props.examSession.isSecCameraRequired? renderBeforeTestDaySecCamera(isEu, i18n.language): null }
                       {props.examSession.isSecCameraRequired? renderOnTestDaySecCamera(): null}
                   </>}
                </div>
            </div>
        </main>
    );
}

export default Main;
